import type { ImpressionEvent } from '@material-bank/analytics-events-ts/mtag'
import { SOURCE_APP } from '../config/eventNames'
import { omitEmpty } from './omitEmpty'

// Our registries describe interactions with a context/element/feature triplet, while the
// canonical `impression_event` (mb3-aligned) uses action/component/section. It declares no
// `element`, so the element travels inside `impression_type` — the analyticsId, which is
// itself `{context}_{element}_{feature}`:
//   interaction_context  -> component
//   interaction_feature  -> section

export type InteractionContextData = {
  /** The variant SKU: impression_event identifies products by sku, not product_id. */
  sku?: string
  productName?: string
  brand?: string
  cartId?: string
  projectId?: string
  selectedValue?: string
  url?: string
}

function currentUrl(explicit?: string): string {
  if (explicit) {
    return explicit
  }

  return typeof window !== 'undefined' ? window.location.href : ''
}

export function buildImpressionEvent(
  impression: {
    impressionType: string
    page: string
    legacyComponent: string
    legacySection: string
  },
  data: InteractionContextData = {},
  action = 'view',
): ImpressionEvent {
  return omitEmpty({
    action,
    impression_type: impression.impressionType,
    page: impression.page,
    component: impression.legacyComponent,
    section: impression.legacySection,
    value: data.selectedValue,
    source_app: SOURCE_APP,
    sku: data.sku,
    product_name: data.productName,
    brand: data.brand,
    cart_id: data.cartId,
    project_id: data.projectId,
    url: currentUrl(data.url),
  }) as ImpressionEvent
}
